export const description =
  "Isoler vos combles supprime jusqu'à 30 % des déperditions thermiques. Cumul MaPrimeRénov’ + Prime CEE + Coup de pouce + éco-PTZ + TVA 5,5 % en 2026.";
